import { TranscricaoHistoricoStatus } from '../../../../interfaces/entities/Transcricao/TranscricaoHistoricoStatus';
import { normalizeCodStatusTranscricao } from '../transcricaoStatusUtils';
import { formatTranscricaoDataCompleta } from './transcricaoDetalheUtils';

const formatDataMensagemCurta = (raw?: string): string | undefined => {
  const formatted = formatTranscricaoDataCompleta(raw);
  if (formatted === '—') return undefined;
  return formatted.split(' às ')[0];
};

export const getPendenciaMensagemCardFromHistoricoStatus = (
  status?: TranscricaoHistoricoStatus | null,
): { mensagem?: string; dataMensagem?: string } => {
  if (normalizeCodStatusTranscricao(status?.codStatusTranscricao) !== 'SOLINF') {
    return {};
  }

  return {
    mensagem: status?.descrStatusTranscricao?.trim() || undefined,
    dataMensagem: formatDataMensagemCurta(status?.dataOperacao),
  };
};
